<template>
  <img
    v-if="showLogo"
    alt="User Portal"
    :src="logoUrl"
    :class="$style.logo"
    @error="imageLoadError"
  >
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import LocalStorageService from 'client/util/LocalStorageService';

const { orgLogoUrl } = LocalStorageConsts;

export default {
  name: 'LoginLogo',
  data() {
    return {
      logoUrl: '',
    };
  },

  computed: {
    showLogo() {
      return !!this.logoUrl;
    },
  },

  mounted() {
    this.getLogo();
  },

  LocalStorageService,

  methods: {
    imageLoadError() {
      this.logoUrl = '';
    },

    getLogo() {
      let imageUrl;

      if (this.$route) {
        const { logoUrl } = this.$route.query;
        if (logoUrl) imageUrl = decodeURIComponent(logoUrl);
      }

      if (imageUrl) {
        this.$options.LocalStorageService.setItem(orgLogoUrl, imageUrl);
        this.logoUrl = imageUrl;
      } else {
        this.logoUrl = this.$options.LocalStorageService.getValue(orgLogoUrl);
      }
    },
  },
};
</script>

<style module>
@import '../css/login-components.css';
</style>
